
export const PRODUCT_TYPES_REQUEST = 'PRODUCT_TYPES_REQUEST';
export const PRODUCT_TYPES_SUCCESS = 'PRODUCT_TYPES_SUCCESS';
export const PRODUCT_TYPES_FAIL = 'PRODUCT_TYPES_FAIL';

export const CREATE_PRODUCT_TYPE_REQUEST = 'CREATE_PRODUCT_TYPE_REQUEST';
export const CREATE_PRODUCT_TYPE_SUCCESS = 'CREATE_PRODUCT_TYPE_SUCCESS';
export const CREATE_PRODUCT_TYPE_FAIL = 'CREATE_PRODUCT_TYPE_FAIL';
